<template>
	<nuxt-link
		v-if="article"
		:id="article.uuid"
		:to="'/' + article.full_slug"
		:aria-label="article.content?.title"
		class="relative flex flex-col"
	>
		<nuxt-picture
			v-if="article.content?.image?.filename"
			:src="article.content.image.filename"
			:alt="article.content?.image?.alt ?? article.content?.title"
			loading="lazy"
			provider="storyblok"
			sizes="xs:50vw sm:320px md:384px lg:512px xl:640px 2xl:768px"
			:img-attrs="{
				class:
					'rounded-2xs object-cover w-full h-[8rem] sm:h-[10rem] lg:h-[14rem]',
			}"
		/>

		<div
			class="mt-3 flex w-full flex-col items-start justify-start space-x-0 align-top"
		>
			<v-h6 tag="h5" class="text-lg! leading-5 md:text-xl!">
				{{ article.content?.title }}
			</v-h6>

			<div
				v-if="article.content?.ingress"
				class="mt-1 line-clamp-3 text-gray-750"
			>
				<sb-rich-text
					:document="article.content?.ingress"
					class="**:leading-tight **:lg:leading-snug"
				/>
			</div>
		</div>
	</nuxt-link>
</template>

<script setup lang="ts">
defineProps<{
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	article: any;
}>();
</script>
